<div class="custom-row">
  @if(mode === "read" && leadStatus !== approvedStatus  && !readOnly){
    <ppl-button 
    label="Edit" 
    icon="fa fa-pencil" 
    [customClass]="'ghost-button'" 
    [iconPosition]="'left'"
    (click)="editPersonalInfo()"
    *authorize="[pageId, tabId, 'Demographics', 'section', 'edit']"
    ></ppl-button>    
  <!-- <span (click)="editPersonalInfo()" nz-icon nzType="edit" nzTheme="outline"
    *authorize="[pageId, tabId, 'Demographics', 'section', 'edit']"></span> -->
  }

</div>
@if(mode==="edit"){
<div class="ppl-mt20">
  <form nz-form nz-row [formGroup]="infoForm" class="ppl-p0">
      @if(isAttrAvailable('legalName')){
      <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
        <nz-row>
          <nz-form-label nzFor="legalName" [nzSm]="8" [nzXs]="24" class="ppl-form-label">{{ getAttributes("legalName").label }}
            @if(getAttributes('legalName').mandatory === 'Y'){
            <span>*</span>
            }
          </nz-form-label>
          <nz-form-control class="ppl-form-control">
            <input nz-tooltip nzTooltipTitle="{{ getAttributes('legalName').tooltip }}" nzTooltipPlacement="topRight"
              nz-input formControlName="legalName" nzId="legalName" autocomplete="off"
              [authorizeField]="[pageId, tabId, 'Demographics', 'legalName']" placeholder="{{ getAttributes('legalName').placeholder }}"
              [ngClass]="{'error': validationErrors['legalName'] }" />
            @if (validationErrors['legalName']) {
            <span class="pl-1 error-message">{{validationErrors['legalName']}}</span>
            }
  
          </nz-form-control>
        </nz-row>
  
      </nz-form-item>
      }
      @if(isAttrAvailable('businessName')){
      <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
        <nz-row>
          <nz-form-label nzFor="businessName" [nzSm]="8" [nzXs]="24" class="ppl-form-label">{{ getAttributes("businessName").label }}
            @if(getAttributes('businessName').mandatory === 'Y'){
            <span>*</span>
            }
          </nz-form-label>
          <nz-form-control class="ppl-form-control">
            <input nz-tooltip nzTooltipTitle="{{ getAttributes('businessName').tooltip }}" nzTooltipPlacement="topRight"
              nz-input formControlName="businessName" nzId="businessName"
              [authorizeField]="[pageId, tabId, 'Demographics', 'businessName']" placeholder="{{ getAttributes('businessName').placeholder }}"
              [ngClass]="{'error': validationErrors['businessName'] }" />
            @if (validationErrors['businessName']) {
            <span class="pl-1 error-message">{{validationErrors['businessName']}}</span>
            }
  
          </nz-form-control>
        </nz-row>
  
      </nz-form-item>
      }
      @if(isAttrAvailable('vendorName')){
      <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
        <nz-row>
          <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="vendorName"
            class="ppl-form-label">{{getAttributes('vendorName').label}}
            @if(getAttributes('vendorName').mandatory === 'Y'){
            <span>*</span>
            }
          </nz-form-label>
          <nz-form-control class="ppl-form-control">
            <div nz-tooltip [nzTooltipTitle]="getAttributes('vendorName')?.tooltip || ''" nzTooltipPlacement="topRight">
              <input nz-input formControlName="vendorName" id="vendorName"
                [authorizeField]="[pageId, tabId, 'Demographics', 'vendorName']" placeholder="{{getAttributes('vendorName').placeholder}}"
                [ngClass]="{'error': validationErrors['vendorName'] }" />
            </div>
            @if (validationErrors['vendorName']) {
            <span class="pl-1 error-message">{{validationErrors['vendorName']}}</span>
            }
          </nz-form-control>
        </nz-row>
      </nz-form-item>
      }
      @if(isAttrAvailable('doingBusinessAs')){
      <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
        <nz-row>
          <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="doingBusinessAs"
          class="ppl-form-label">{{getAttributes('doingBusinessAs').label}}
            @if(getAttributes('doingBusinessAs').mandatory === 'Y'){
              <span>*</span>
            }
          </nz-form-label>
          <nz-form-control class="ppl-form-control">
            <div nz-tooltip [nzTooltipTitle]="getAttributes('doingBusinessAs')?.tooltip || ''" nzTooltipPlacement="topRight">
              <input nz-input formControlName="dbaName" id="doingBusinessAs"
              [authorizeField]="[pageId, tabId, 'Demographics', 'doingBusinessAs']" placeholder="{{getAttributes('doingBusinessAs').placeholder}}"
              [ngClass]="{'error': validationErrors['doingBusinessAs'] }" />
            </div>
            @if (validationErrors['doingBusinessAs']) {
            <span class="pl-1 error-message">{{validationErrors['doingBusinessAs']}}</span>
            }
          </nz-form-control>
        </nz-row>
      </nz-form-item>
      }
    @if(isAttrAvailable('fname')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label nzFor="fname" [nzSm]="8" [nzXs]="24" class="ppl-form-label">{{ getAttributes("fname").label }}
          @if(getAttributes('fname').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <input nz-tooltip nzTooltipTitle="{{ getAttributes('fname').tooltip }}" nzTooltipPlacement="topRight"
            nz-input formControlName="fname" nzId="fname"
            [authorizeField]="[pageId, tabId, 'Demographics', 'fname']" placeholder="{{ getAttributes('fname').placeholder }}"
            [ngClass]="{'error': validationErrors['fname'] }" />
          @if (validationErrors['fname']) {
          <span class="pl-1 error-message">{{validationErrors['fname']}}</span>
          }

        </nz-form-control>
      </nz-row>

    </nz-form-item>
    } @if(isAttrAvailable('mname')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="mname" class="ppl-form-label">{{ getAttributes("mname").label }}
          @if(getAttributes('mname').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <input nz-tooltip nzTooltipTitle="{{ getAttributes('mname').tooltip }}" nzTooltipPlacement="topRight"
            nz-input formControlName="mname" nzId="mname"
            [authorizeField]="[pageId, tabId, 'Demographics', 'mname']" placeholder="{{ getAttributes('mname').placeholder }}"
            [ngClass]="{'error': validationErrors['mname'] }" />
          @if (validationErrors['mname']) {
          <span class="pl-1 error-message">{{validationErrors['mname']}}</span>
          }
        </nz-form-control>
      </nz-row>

    </nz-form-item>
    } @if(isAttrAvailable('lname')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="lname" class="ppl-form-label">{{ getAttributes("lname").label }}
          @if(getAttributes('lname').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <input nz-tooltip nzTooltipTitle="{{ getAttributes('lname').tooltip }}" nzTooltipPlacement="topRight"
            nz-input formControlName="lname" nzId="lname"
            [authorizeField]="[pageId, tabId, 'Demographics', 'lname']" placeholder="{{ getAttributes('lname').placeholder }}"
            [ngClass]="{'error': validationErrors['lname'] }" />
          @if (validationErrors['lname']) {
          <span class="pl-1 error-message">{{validationErrors['lname']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>} @if(isAttrAvailable('maiden_name')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" class="ppl-form-label" nzFor="maiden_name">{{
          getAttributes("maiden_name").label }}
          @if(getAttributes('maiden_name').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <input nz-tooltip nzTooltipTitle="{{ getAttributes('maiden_name').tooltip }}" nzTooltipPlacement="topRight"
            nz-input formControlName="maiden_name" nzId="maiden_name"
            [authorizeField]="[pageId, tabId, 'Demographics', 'maiden_name']"
            placeholder="{{ getAttributes('maiden_name').placeholder }}"
            [ngClass]="{'error': validationErrors['maiden_name'] }" />
          @if (validationErrors['maiden_name']) {
          <span class="pl-1 error-message">{{validationErrors['maiden_name']}}</span>
          }
        </nz-form-control>
      </nz-row>

    </nz-form-item>
    } @if(isAttrAvailable('dob')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="dob" class="ppl-form-label">{{ getAttributes("dob").label }}
          @if(getAttributes('dob').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control nzSpan="24" class="ppl-form-control">
          <!-- <nz-date-picker nzSpan="24" formControlName="dob" nzId="dob" nz-tooltip [nzAllowClear]="false"
            [authorizeField]="[pageId, tabId, 'Demographics', 'dob']" nzTooltipTitle="{{ getAttributes('dob').tooltip }}"
            nzTooltipPlacement="topRight" [nzPlaceHolder]="getAttributes('dob').placeholder"
            [ngClass]="{'error': validationErrors['dob'] }" [nzFormat]="'MM/dd/yyyy'"></nz-date-picker> -->
          <ppl-date-picker formControlName="dob" id="dob" [showIcon]="true" [authorizeField]="[pageId, tabId, 'Demographics', 'dob']"
          [placeholder]="getAttributes('dob').placeholder" dateFormat="mm/dd/yy" [readonlyInput]="false"
          [monthNavigator]="true" [yearNavigator]="true" [yearRange]="'1900:2050'" [iconDisplay]="'input'"
          inputId="icondisplay" [panelStyleClass]="'custom-calendar-panel'"
          [styleClass]="validationErrors['dob'] ? 'error' : ''">
          </ppl-date-picker>
          @if (validationErrors['dob']) {
          <span class="pl-1 error-message">{{validationErrors['dob']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>} @if(isAttrAvailable('gender')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="gender" [authorizeField]="[pageId, tabId, 'Demographics', 'gender']"
          class="ppl-form-label">{{ getAttributes("gender").label }}
          @if(getAttributes('gender').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nzLabelAlign="left">
          <div [ngClass]="{'error': validationErrors['gender'] }">
            <ppl-dropdown-select nz-tooltip nzTooltipTitle="{{getAttributes('gender').tooltip}}" nzTooltipPlacement="topRight"
              formControlName="gender" id="gender" [options]="genderList" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
            </ppl-dropdown-select>
          </div>
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }
    @if(isAttrAvailable('conservatorship')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="conservatorship" class="ppl-form-label">{{ getAttributes("conservatorship").label }}
          @if(getAttributes('conservatorship').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nzLabelAlign="left">
          <div [ngClass]="{'error': validationErrors['conservatorship'] }">
            <ppl-dropdown-select nz-tooltip nzTooltipTitle="{{getAttributes('conservatorship').tooltip}}" nzTooltipPlacement="topRight"
              formControlName="conservatorship" id="conservatorship" [options]="availableConservatorshipTypes" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
            </ppl-dropdown-select>
          </div>
          @if (validationErrors['conservatorship']) {
          <span class="pl-1 error-message">{{validationErrors['conservatorship']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }
    @if(isAttrAvailable('servicesAtBusinessLocation')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="servicesAtBusinessLocation" [authorizeField]="[pageId, tabId, 'Demographics', 'servicesAtBusinessLocation']"
          class="ppl-form-label">
          {{getAttributes('servicesAtBusinessLocation').label}}
          @if(getAttributes('servicesAtBusinessLocation').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nzLabelAlign="left">
          <div nz-tooltip nzTooltipTitle="{{getAttributes('servicesAtBusinessLocation').tooltip}}" nzTooltipPlacement="topRight"
            [ngClass]="{'error': validationErrors['servicesAtBusinessLocation'] }">
            <nz-radio-group formControlName="servicesAtBusinessLocation" class="ppl-radio-group" id="servicesAtBusinessLocation">
              @for(opt of radioOptions; track $index){
              <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['servicesAtBusinessLocation']) {
          <span class="pl-1 error-message">{{validationErrors['servicesAtBusinessLocation']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }
    @if(isAttrAvailable('servingIndividualsWithDisabilities')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="servingIndividualsWithDisabilities" [authorizeField]="[pageId, tabId, 'Demographics', 'servingIndividualsWithDisabilities']"
          class="ppl-form-label">
          {{getAttributes('servingIndividualsWithDisabilities').label}}
          @if(getAttributes('servingIndividualsWithDisabilities').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nzLabelAlign="left">
          <div nz-tooltip nzTooltipTitle="{{getAttributes('servingIndividualsWithDisabilities').tooltip}}" nzTooltipPlacement="topRight"
            [ngClass]="{'error': validationErrors['servingIndividualsWithDisabilities'] }">
            <nz-radio-group formControlName="servingIndividualsWithDisabilities" class="ppl-radio-group" id="servingIndividualsWithDisabilities">
              @for(opt of radioOptions; track $index){
              <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['servingIndividualsWithDisabilities']) {
          <span class="pl-1 error-message">{{validationErrors['servingIndividualsWithDisabilities']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }
    @if(isAttrAvailable('state')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="state" class="ppl-form-label"
          [authorizeField]="[pageId, tabId, 'Demographics', 'state']">{{ getAttributes("state").label }}
          @if(getAttributes('state').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('state').tooltip}}">
          <div [ngClass]="{'error': validationErrors['state'] }">
            <ppl-dropdown-select formControlName="state" id="state"
            [options]="statesList" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
            </ppl-dropdown-select>
          </div>
          @if (validationErrors['state']) {
          <span class="pl-1 error-message">{{validationErrors['state']}}</span>
          }
        </nz-form-control>
        
      </nz-row>

    </nz-form-item>
    }
    @if(isAttrAvailable('regionalCenterValue')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="regionalCenterValue" class="ppl-form-label"
          [authorizeField]="[pageId, tabId, 'Demographics', 'regionalCenterValue']">{{ getAttributes("regionalCenterValue").label }}
          @if(getAttributes('regionalCenterValue').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('regionalCenterValue').tooltip}}">
          <div [ngClass]="{'error': validationErrors['regionalCenterValue'] }">
            <ppl-dropdown-select formControlName="regionalCenter" id="regionalCenter"
            [options]="regionalCenterList" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
            </ppl-dropdown-select>
          </div>
          @if (validationErrors['regionalCenterValue']) {
          <span class="pl-1 error-message">{{validationErrors['regionalCenterValue']}}</span>
          }
        </nz-form-control>
        
      </nz-row>

    </nz-form-item>
    }
    @if(isAttrAvailable('relationToParticipant')){
      <!-- <div nz-col [nzSm]="6" [nzXs]="24"> -->
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
          <nz-row>
          <nz-form-label [nzSm]="8" [nzXs]="24"  zFor="relationToParticipant"
            class="ppl-form-label">{{getAttributes('relationToParticipant').label}}
            @if(getAttributes('relationToParticipant').mandatory === 'Y'){
            <span>*</span>
            }</nz-form-label>
          <nz-form-control  class="ppl-form-control" nz-tooltip
            nzTooltipTitle="{{getAttributes('relationToParticipant').tooltip}}" nzLabelAlign="left">
            <div [ngClass]="{'error': validationErrors['relationToParticipant'] }">
              <ppl-dropdown-select formControlName="relationToParticipant"
              [id]="'relationToParticipant' + sectionName" placeholder="Select relation to Participant"
              [options]="relationshipOptions" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
              </ppl-dropdown-select>
            </div>
            @if (validationErrors['relationToParticipant']) {
            <span class="pl-1 error-message">{{validationErrors['relationToParticipant']}}</span>
            }
          </nz-form-control>
        </nz-row>
        </nz-form-item>
      <!-- </div> -->
      }

      @if(isAttrAvailable('nonProfitStatus')){
        <nz-form-label [nzSpan]="24" nzFor="nonProfitStatus" class="ppl-form-label"
          style="margin:0 0 0 16px;">{{getAttributes('nonProfitStatus').label}}
          @if(getAttributes('nonProfitStatus').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
          <nz-row>
          <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="taxExempt"
                class="ppl-form-label">{{getAttributes('taxExempt').label}}
                @if(getAttributes('taxExempt').mandatory === 'Y'){
                <span>*</span>
                }</nz-form-label>
              <nz-form-control class="ppl-form-control">
                <div [ngClass]="{'error': validationErrors['taxExempt'] }">
                  <ppl-dropdown-select formControlName="taxExempt" [id]="'taxExempt' + sectionName"
                  placeholder="{{getAttributes('taxExempt').placeholder}}"
                  [options]="taxExemptOptions" [optionLabel]="'lkpValueName'" optionValue="'lkpValueCode'">
                  </ppl-dropdown-select>
                </div>
                @if (validationErrors['taxExempt']) {
                <span class="pl-1 error-message">{{validationErrors['taxExempt']}}</span>
                }
              </nz-form-control>
            </nz-row>
            </nz-form-item>
      
        
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
              <nz-row>
              <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="nprftDocumentationReceived"
                class="ppl-form-label">{{getAttributes('nprftDocumentationReceived').label}}
                @if(getAttributes('nprftDocumentationReceived').mandatory === 'Y'){
                <span>*</span>
                }</nz-form-label>
              <nz-form-control class="ppl-form-control">
                <div style="width:100%; margin-bottom: 16px" [ngClass]="{'error': validationErrors['nprftDocumentationReceived'] }">
                  <ppl-dropdown-select formControlName="nprftDocumentationReceived" id="nprftDocumentationReceived"
                  placeholder="{{getAttributes('nprftDocumentationReceived').placeholder}}" [options]="nprftDocumentationReceivedOptions" [optionLabel]="'label'" [optionValue]="'value'">
                  </ppl-dropdown-select>
                </div>
                @if (validationErrors['nprftDocumentationReceived']) {
                <span class="pl-1 error-message">{{validationErrors['nprftDocumentationReceived']}}</span>
                }
              </nz-form-control>
            </nz-row>
            </nz-form-item>
        }
      @if(isAttrAvailable('isShowOnDirectory')){
        <nz-form-item nz-col nzSpan="16" class="ppl-form-item nz-padding-left">
          <nz-row>
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="isShowOnDirectory" [authorizeField]="[pageId, tabId, 'Demographics', 'isShowOnDirectory']"
            class="ppl-form-label">{{getAttributes('isShowOnDirectory').label}}
            @if(getAttributes('isShowOnDirectory').mandatory === 'Y'){
            <span>*</span>
            }
          </nz-form-label>
          <nz-form-control  class="ppl-form-control"  [nzSm]="6" [nzXs]="24" nz-tooltip
          nzTooltipTitle="{{getAttributes('isShowOnDirectory').tooltip}}" nzLabelAlign="left">
              <div [ngClass]="{'error': validationErrors['isShowOnDirectory'] }">
                <ppl-dropdown-select formControlName="isShowOnDirectory" [id]="'isShowOnDirectory'  + sectionName"
                [options]="radioOptions" [optionLabel]="'label'" [optionValue]="'value'">
                </ppl-dropdown-select>
              </div>
              <!-- <nz-radio-group [ngClass]="{'error': validationErrors['isShowOnDirectory'] }" nz-tooltip [nzTooltipTitle]="getAttributes('isShowOnDirectory')?.tooltip || ''"
              nzTooltipPlacement="topRight" formControlName="isShowOnDirectory" class="ppl-radio-group" nzId="isShowOnDirectory"  nzLabelAlign="left">
                @for(opt of radioOptions; track $index){
                  <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
                }
              </nz-radio-group> -->
            @if (validationErrors['isShowOnDirectory']) {
            <span class="pl-1 error-message">{{validationErrors['isShowOnDirectory']}}</span>
            }
          </nz-form-control>
          </nz-row>
          
        </nz-form-item>
        }

        @if(isAttrAvailable('isProvidingServices')){
          <nz-form-item nz-col nzSpan="16" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
            <nz-row>
              <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="isProvidingServices" [authorizeField]="[pageId, tabId, 'Demographics', 'isProvidingServices']"
              class="ppl-form-label">{{getAttributes('isProvidingServices').label}}
              @if(getAttributes('isProvidingServices').mandatory === 'Y'){
              <span>*</span>
              }
            </nz-form-label>
            <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('isProvidingServices').tooltip}}" nzTooltipPlacement="topRight" nzLabelAlign="left">
              <div [ngClass]="{'error': validationErrors['isProvidingServices'] }">
                <ppl-dropdown-select formControlName="isProvidingServices" [id]="'isProvidingServices'  + sectionName"
                [options]="radioOptions" [optionLabel]="'label'" [optionValue]="'value'">
                </ppl-dropdown-select>
              </div>
              @if (validationErrors['isProvidingServices']) {
              <span class="pl-1 error-message">{{validationErrors['isProvidingServices']}}</span>
              }
            </nz-form-control>
            </nz-row>
            
          </nz-form-item>
          }

          @if(isAttrAvailable('yearsInState')){
            <nz-form-item nz-col nzSpan="16" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
              <nz-row>
                <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="yearsInState" [authorizeField]="[pageId, tabId, 'Demographics', 'yearsInState']"
                class="ppl-form-label">{{getAttributes('yearsInState').label}}
                @if(getAttributes('yearsInState').mandatory === 'Y'){
                <span>*</span>
                }
              </nz-form-label>
              <nz-form-control class="ppl-form-control"  [nzSm]="6" [nzXs]="24" nz-tooltip
              nzTooltipTitle="{{getAttributes('yearsInState').tooltip}}" nzLabelAlign="left">
              <input nz-tooltip nzTooltipTitle="{{ getAttributes('yearsInState').tooltip }}" nzTooltipPlacement="topRight"
              nz-input formControlName="yearsInState" nzId="yearsInState"
              [authorizeField]="[pageId, tabId, 'Demographics', 'yearsInState']"
              placeholder="{{ getAttributes('yearsInState').placeholder }}"
              [ngClass]="{'error': validationErrors['yearsInState'] }" />
                @if (validationErrors['yearsInState']) {
                <span class="pl-1 error-message">{{validationErrors['yearsInState']}}</span>
                }
              </nz-form-control>
              </nz-row>
              
            </nz-form-item>
            }
    @if(isAttrAvailable('additionalDemographics')){
      
      <nz-divider></nz-divider>
        <nz-form-label [nzSpan]="24" [nzXs]="24" nzFor="additionalDemographics" class="ppl-form-label"
          style="margin:8px 0 24px 0;">{{getAttributes('additionalDemographics').label}}
          @if(getAttributes('additionalDemographics').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
     
          @if(isAttrAvailable('race')){
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
          <nz-row> 
          <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="race" class="ppl-form-label">{{getAttributes('race').label}}
                @if(getAttributes('race').mandatory === 'Y'){
                <span>*</span>
                }
              </nz-form-label>
              <nz-form-control class="ppl-form-control" nz-tooltip
                nzTooltipTitle="{{getAttributes('race').tooltip}}" nzTooltipPlacement="topRight">
          <div [ngClass]="{'error': validationErrors['race'] }">
            <ppl-dropdown-select formControlName="race" [id]="'race'  + sectionName"
            [options]="raceOptions" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
            </ppl-dropdown-select>
          </div>
                
                @if (validationErrors['race']) {
                <span class="pl-1 error-message">{{validationErrors['race']}}</span>
                }
              </nz-form-control>
            </nz-row>
            </nz-form-item>
          }
          @if(isAttrAvailable('height')){
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
              <nz-row> 
              <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="height" class="ppl-form-label">{{getAttributes('height').label}}
                @if(getAttributes('height').mandatory === 'Y'){
                <span>*</span>
                }
              </nz-form-label>
              <nz-form-control class="ppl-form-control">
                <div nz-tooltip [nzTooltipTitle]="getAttributes('height')?.tooltip || ''" nzTooltipPlacement="topRight"
                  class="height-input-container ppl-form-control">
                  <nz-row [nzGutter]="16">
                    <nz-col [nzSm]="12" [nzXs]="24">
                      <input nz-input formControlName="heightFeet" [id]="'heightFeet'  + sectionName" placeholder="Feet"
                        [ngClass]="{'error': validationErrors['heightFeet']}" />
                        @if (validationErrors['heightFeet']) {
                          <span class="pl-1 error-message">{{validationErrors['heightFeet']}}</span>
                          }
                    </nz-col>
                    <nz-col [nzSm]="12" [nzXs]="24">
                      <input nz-input formControlName="heightInches" [id]="'heightInches'  + sectionName" placeholder="Inches"
                        [ngClass]="{'error': validationErrors['heightInches']}" />
                        @if  (validationErrors['heightInches']) {
                        <span class="pl-1 error-message">{{validationErrors['heightInches']}}</span>
                        }
                      </nz-col>
                  </nz-row>
                </div>
              </nz-form-control>
            </nz-row>
            </nz-form-item>
         
          }
          @if(isAttrAvailable('weight')){
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
              <nz-row>
                <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="weight" class="ppl-form-label">
                  {{getAttributes('weight').label}}
                  @if(getAttributes('weight').mandatory === 'Y'){
                  <span>*</span>
                  }
                </nz-form-label>
                <nz-form-control  class="ppl-form-control">
                  <div nz-tooltip [nzTooltipTitle]="getAttributes('weight')?.tooltip || ''" nzTooltipPlacement="topRight"
                    class="weight-input-container ppl-form-control">
                    <input nz-input formControlName="weight" [id]="'weight'  + sectionName"
                      placeholder="{{getAttributes('weight').placeholder}}" [ngClass]="{'error': validationErrors['weight']}" />
                    <!-- <span class="unit-label">Pounds</span> -->
                  </div>
                  @if (validationErrors['weight']) {
                    <span class="pl-1 error-message">{{validationErrors['weight']}}</span>
                    }
                </nz-form-control>
              </nz-row>
              </nz-form-item>
            }
            @if(isAttrAvailable('eyeColor')){
              <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                <nz-form-label  [nzSm]="8" [nzXs]="24" nzFor="eyeColor" class="ppl-form-label">{{getAttributes('eyeColor').label}}
                  @if(getAttributes('eyeColor').mandatory === 'Y'){
                  <span>*</span>
                  }
                </nz-form-label>
                <nz-form-control class="ppl-form-control" nz-tooltip
                  nzTooltipTitle="{{getAttributes('eyeColor').tooltip}}" nzTooltipPlacement="topRight">
                  <div [ngClass]="{'error': validationErrors['eyeColor'] }">
                    <ppl-dropdown-select formControlName="eyeColor" [id]="'eyeColor'  + sectionName"
                    [options]="eyeColors" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
                    </ppl-dropdown-select>
                  </div>

                  @if (validationErrors['eyeColor']) {
                  <span class="pl-1 error-message">{{validationErrors['eyeColor']}}</span>
                  }
                </nz-form-control>
              </nz-row>
              </nz-form-item>
            }
          @if(isAttrAvailable('hairColor')){
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
              <nz-row>
              <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="hairColor" class="ppl-form-label">{{getAttributes('hairColor').label}}
                @if(getAttributes('hairColor').mandatory === 'Y'){
                <span>*</span>
                }
              </nz-form-label>
              <nz-form-control class="ppl-form-control" nz-tooltip
                nzTooltipTitle="{{getAttributes('hairColor').tooltip}}" nzTooltipPlacement="topRight">
                <div [ngClass]="{'error': validationErrors['hairColor'] }">
                  <ppl-dropdown-select formControlName="hairColor" [id]="'hairColor'  + sectionName"
                  [options]="hairColors" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
                  </ppl-dropdown-select>
                </div>
                @if (validationErrors['hairColor']) {
                <span class="pl-1 error-message">{{validationErrors['hairColor']}}</span>
                }
              </nz-form-control>
            </nz-row>
            </nz-form-item>
          
          }
          @if(isAttrAvailable('birthPlace')){
            <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
              <nz-row>

              <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="birthPlace" class="ppl-form-label">{{getAttributes('birthPlace').label}}
                  @if(getAttributes('birthPlace').mandatory === 'Y'){
                  <span>*</span>
                  }
                </nz-form-label>
                <nz-form-control  class="ppl-form-control">
                  <div nz-tooltip [nzTooltipTitle]="" nzTooltipPlacement="topRight">
                    <input nz-input formControlName="birthCity" [id]="'birthCity'  + sectionName" placeholder="City" />
                  </div>
                </nz-form-control>
                <nz-form-control  class="ppl-form-control" style="margin: 0px 4px;">
                  <div nz-tooltip [nzTooltipTitle]="" nzTooltipPlacement="topRight">
                    <input nz-input formControlName="birthState" [id]="'state'  + sectionName" placeholder="State" />
                  </div>
                </nz-form-control>
                <nz-form-control  class="ppl-form-control">
                  <div nz-tooltip [nzTooltipTitle]="" nzTooltipPlacement="topRight">
                    <input nz-input formControlName="birthCountry" [id]="'country'  + sectionName" placeholder="Country" />
                  </div>
                </nz-form-control>
              </nz-row>
              </nz-form-item>
            
            }
      }
    
        <!-- @if(isAttrAvailable('mobile')){
  
          <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
            <nz-row>
            <nz-form-label  [nzSm]="8" [nzXs]="24" nzFor="mobile" class="ppl-form-label"
              [ngStyle]="{ 'margin-bottom':'0' }">{{getAttributes('mobile').label}}
              @if(getAttributes('mobile').mandatory === 'Y'){
              <span>*</span>
              }
            </nz-form-label>
            <nz-form-control>
              <input nz-tooltip nzTooltipTitle="{{getAttributes('mobile').tooltip}}" nzTooltipPlacement="topRight"
                nz-input [id]="'mobile'" formControlName="mobile"
                [ngClass]="{'error': validationErrors['mobile'] }"
                placeholder="{{getAttributes('mobile').placeholder}}" />
              @if (validationErrors['mobile']) {
              <span class="pl-1 error-message">{{validationErrors['mobile']}}</span>
              }
            </nz-form-control>
          </nz-row>
          </nz-form-item>
        } -->
        @if(isAttrAvailable('registerPref')){
          <nz-form-item nz-col nzSpan="16" class="ppl-form-item nz-padding-left">
            <nz-row>
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="registerPref"
            class="ppl-form-label">{{getAttributes('registerPref').label}}
            @if(getAttributes('registerPref').mandatory === 'Y'){
            <span>*</span>
            }
          </nz-form-label>
         
            <nz-form-control class="ppl-form-control" [nzSm]="6" [nzXs]="24"  nz-tooltip nzTooltipTitle="{{getAttributes('registerPref').tooltip}}"
              nzTooltipPlacement="topRight">
              <div [ngClass]="{'error': validationErrors['registerPref'] }">
                <ppl-dropdown-select formControlName="registerPref" [id]="'registerPref'  + sectionName"
                [options]="participantRegisterMode" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"></ppl-dropdown-select>
              </div>
              @if (validationErrors['registerPref']) {
              <span class="pl-1 error-message">{{validationErrors['registerPref']}}</span>
              }
            </nz-form-control>
          </nz-row>
        </nz-form-item>
        }
        
     
    @if(isAttrAvailable('waiver')){
      <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
        <nz-row>
          <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="waiver" class="ppl-form-label"
          [authorizeField]="[pageId, tabId, 'Demographics', 'waiver']">{{ getAttributes("waiver").label }}
          @if(getAttributes('waiver').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('waiver').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{'error': validationErrors['waiver'] }">
            <ppl-dropdown-select formControlName="waiver" id="waiver" placeholder="Select Service Administration"
            [options]="waiver" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
            </ppl-dropdown-select>
          </div>
          @if (validationErrors['waiver']) {
          <span class="pl-1 error-message">{{validationErrors['waiver']}}</span>
          }
        </nz-form-control>
      </nz-row>
      </nz-form-item>
      }
      @if(isAttrAvailable('ldssOffice')){
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
          <nz-row>
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="ldssOffice" class="ppl-form-label"
            [authorizeField]="[pageId, tabId, 'Demographics', 'ldssOffice']">{{ getAttributes("ldssOffice").label }}
            @if(getAttributes('ldssOffice').mandatory === 'Y'){
            <span>*</span>
            }</nz-form-label>
          <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('ldssOffice').tooltip}}"
            nzTooltipPlacement="topRight">
            <div [ngClass]="{'error': validationErrors['ldssOffice'] }">
              <ppl-dropdown-select formControlName="ldssOffice" id="ldssOffice" placeholder="Select LDSS Office"
              [options]="ldssOfficeValues" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
              </ppl-dropdown-select>
            </div>
            @if (validationErrors['ldssOffice']) {
            <span class="pl-1 error-message">{{validationErrors['ldssOffice']}}</span>
            }
          </nz-form-control>
        </nz-row>
        </nz-form-item>
        }
      @if(isAttrAvailable('mcoOrgName')){
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
          <nz-row>
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="mcoOrgName" class="ppl-form-label"
            [authorizeField]="[pageId, tabId, 'Demographics', 'mcoOrgName']">{{ getAttributes("mcoOrgName").label }}
            @if(getAttributes('mcoOrgName').mandatory === 'Y'){
            <span>*</span>
            }</nz-form-label>
          <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('mcoOrgName').tooltip}}"
            nzTooltipPlacement="topRight">
            <div [ngClass]="{'error': validationErrors['mcoOrgName'] }">
              <ppl-dropdown-select formControlName="mcoOrgName" id="mcoOrgName" placeholder="{{getAttributes('mcoOrgName').tooltip}}"
              [options]="mcoEntries" [optionLabel]="'orgName'" [optionValue]="'orgName'">
              </ppl-dropdown-select>
            </div>
            @if (validationErrors['mcoOrgName']) {
            <span class="pl-1 error-message">{{validationErrors['mcoOrgName']}}</span>
            }
          </nz-form-control>
        </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('currentFI')){
          <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
            <nz-row>
              <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="currentFI" class="ppl-form-label"
              [authorizeField]="[pageId, tabId, 'Demographics', 'currentFI']">{{ getAttributes("currentFI").label }}
              @if(getAttributes('currentFI').mandatory === 'Y'){
              <span>*</span>
              }</nz-form-label>
            <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('currentFI').tooltip}}"
              nzTooltipPlacement="topRight">
              <div [ngClass]="{'error': validationErrors['currentFI'] }">
                <ppl-dropdown-select formControlName="currentFI" id="currentFI" placeholder="Select current FI"
                [options]="currentFIValues" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
                </ppl-dropdown-select>
              </div>
              @if (validationErrors['currentFI']) {
              <span class="pl-1 error-message">{{validationErrors['currentFI']}}</span>
              }
            </nz-form-control>
          </nz-row>
          </nz-form-item>
        }
        @if(isAttrAvailable('fiOrgName') && !isExternalEnvironment){
          <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
            <nz-row>
              <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="fiOrgName" class="ppl-form-label"
              [authorizeField]="[pageId, tabId, 'Demographics', 'fiOrgName']">{{ getAttributes("fiOrgName").label }}
              @if(getAttributes('fiOrgName').mandatory === 'Y'){
              <span>*</span>
              }</nz-form-label>
            <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('fiOrgName').tooltip}}"
              nzTooltipPlacement="topRight">
              <div [ngClass]="{'error': validationErrors['fiOrgName'] }">
                <ppl-dropdown-select formControlName="fiOrgName" id="fiOrgName" placeholder="{{getAttributes('fiOrgName').tooltip}}"
                [options]="fiEntries" [optionLabel]="'orgName'" [optionValue]="'orgName'">
                </ppl-dropdown-select>
                <ng-container *ngIf="infoForm.get('fiOrgName')?.value === 'Other'">
                  <div nz-tooltip class="mt-2">
                    <input nz-input formControlName="newfiOrgName" id="newfiOrgName" placeholder="New {{getAttributes('fiOrgName').label}}"
                      [ngClass]="{'error': validationErrors['newfiOrgName'] }" />
                  </div>
                </ng-container>
              </div>
              @if (validationErrors['fiOrgName']) {
              <span class="pl-1 error-message">{{validationErrors['fiOrgName']}}</span>
              }
              @if (validationErrors['newfiOrgName']) {
              <span class="pl-1 error-message">{{validationErrors['newfiOrgName']}}</span>
              }
            </nz-form-control>
          </nz-row>
          </nz-form-item>
        }
      @if(isAttrAvailable('eligiblityStartDate') && !isExternalEnvironment){
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
          <nz-row>
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="eligiblityStartDate" class="ppl-form-label">{{ getAttributes("eligiblityStartDate").label }}
              @if(getAttributes('eligiblityStartDate').mandatory === 'Y'){
              <span>*</span>
              }</nz-form-label>
            <nz-form-control nzSpan="24" class="ppl-form-control">
              <!-- <nz-date-picker nzSpan="24" formControlName="eligiblityStartDate" nzId="eligiblityStartDate" nz-tooltip
                [authorizeField]="[pageId, tabId, 'Demographics', 'eligiblityStartDate']" nzTooltipTitle="{{ getAttributes('eligiblityStartDate').tooltip }}"
                nzTooltipPlacement="topRight" [nzPlaceHolder]="getAttributes('eligiblityStartDate').placeholder"
                [ngClass]="{'error': validationErrors['eligiblityStartDate'] }" [nzFormat]="'MM/dd/yyyy'"></nz-date-picker> -->
              <ppl-date-picker formControlName="eligiblityStartDate" id="eligiblityStartDate" [showIcon]="true" [authorizeField]="[pageId, tabId, 'Demographics', 'eligiblityStartDate']"
              [placeholder]="getAttributes('eligiblityStartDate').placeholder" dateFormat="mm/dd/yy" [readonlyInput]="false"
              [monthNavigator]="true" [yearNavigator]="true" [yearRange]="'1900:2050'" [iconDisplay]="'input'"
              inputId="icondisplay" [panelStyleClass]="'custom-calendar-panel'"
              [styleClass]="validationErrors['eligiblityStartDate'] ? 'error' : ''"></ppl-date-picker>
              @if (validationErrors['eligiblityStartDate']) {
              <span class="pl-1 error-message">{{validationErrors['eligiblityStartDate']}}</span>
              }
            </nz-form-control>
          </nz-row>
        </nz-form-item>}
      @if(isAttrAvailable('eligiblityEndDate') && !isExternalEnvironment){
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
          <nz-row>
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="eligiblityEndDate" class="ppl-form-label">{{ getAttributes("eligiblityEndDate").label }}
              @if(getAttributes('eligiblityEndDate').mandatory === 'Y'){
              <span>*</span>
              }</nz-form-label>
            <nz-form-control nzSpan="24" class="ppl-form-control">
              <!-- <nz-date-picker nzSpan="24" formControlName="eligiblityEndDate" nzId="eligiblityEndDate" nz-tooltip
                [authorizeField]="[pageId, tabId, 'Demographics', 'eligiblityEndDate']" nzTooltipTitle="{{ getAttributes('eligiblityEndDate').tooltip }}"
                nzTooltipPlacement="topRight" [nzPlaceHolder]="getAttributes('eligiblityEndDate').placeholder"
                [ngClass]="{'error': validationErrors['eligiblityEndDate'] }" [nzFormat]="'MM/dd/yyyy'"></nz-date-picker> -->
                <ppl-date-picker formControlName="eligiblityEndDate" id="eligiblityEndDate" [showIcon]="true" [authorizeField]="[pageId, tabId, 'Demographics', 'eligiblityEndDate']"
              [placeholder]="getAttributes('eligiblityEndDate').placeholder" dateFormat="mm/dd/yy" [readonlyInput]="false"
              [monthNavigator]="true" [yearNavigator]="true" [yearRange]="'1900:2050'" [iconDisplay]="'input'"
              inputId="icondisplay" [panelStyleClass]="'custom-calendar-panel'"
              [styleClass]="validationErrors['eligiblityEndDate'] ? 'error' : ''"></ppl-date-picker>
              @if (validationErrors['eligiblityEndDate']) {
              <span class="pl-1 error-message">{{validationErrors['eligiblityStartDate']}}</span>
              }
            </nz-form-control>
          </nz-row>
        </nz-form-item>
      }
      @if(isAttrAvailable('contactStsReasonLkp') && !isExternalEnvironment){
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
          <nz-row>
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="contactStsReasonLkp" class="ppl-form-label"
            [authorizeField]="[pageId, tabId, 'Demographics', 'contactStsReasonLkp']">{{ getAttributes("contactStsReasonLkp").label }}
            @if(getAttributes('contactStsReasonLkp').mandatory === 'Y'){
            <span>*</span>
            }</nz-form-label>
          <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('contactStsReasonLkp').tooltip}}"
            nzTooltipPlacement="topRight">
            <div [ngClass]="{'error': validationErrors['contactStsReasonLkp'] }">
              <ppl-dropdown-select formControlName="contactStsReasonLkp" id="contactStsReasonLkp" placeholder="{{getAttributes('contactStsReasonLkp').tooltip}}"
              [options]="contactStsReasonLkpList" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
              </ppl-dropdown-select>
            </div>
            @if (validationErrors['contactStsReasonLkp']) {
            <span class="pl-1 error-message">{{validationErrors['contactStsReasonLkp']}}</span>
            }
          </nz-form-control>
        </nz-row>
        </nz-form-item>
      }
      @if(isAttrAvailable('contactStsComments')){
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
          <nz-row>
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="contactStsComments"
            class="ppl-form-label ">{{getAttributes('contactStsComments').label}}
            @if(getAttributes('contactStsComments').mandatory === 'Y'){
            <span>*</span>
            }
          </nz-form-label>
          <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('contactStsComments').tooltip}}"
            nzTooltipPlacement="topRight">
            <textarea rows="4" cols="40" nz-input formControlName="contactStsComments" id="contactStsComments" class="ppl-form-control"
              placeholder="{{getAttributes('contactStsComments').placeholder}}"  [ngClass]="{'error': validationErrors['contactStsComments'] }"></textarea>
              @if (validationErrors['contactStsComments']) {
                <span class="pl-1 error-message">{{validationErrors['contactStsComments']}}</span>
              }
          </nz-form-control>
          
          </nz-row>
          
        </nz-form-item>
      }
      @if(isAttrAvailable('recieveGoodsAndServices') && !isExternalEnvironment){
        <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
          <nz-row>
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="recieveGoodsAndServices" [authorizeField]="[pageId, tabId, 'Demographics', 'recieveGoodsAndServices']"
              class="ppl-form-label">{{ getAttributes("recieveGoodsAndServices").label }}
              @if(getAttributes('recieveGoodsAndServices').mandatory === 'Y'){ <span>*</span> }
            </nz-form-label>
            <nz-form-control class="ppl-form-control" nzLabelAlign="left">
              <ppl-dropdown-select formControlName="recieveGoodsAndServices" id="recieveGoodsAndServices"
                [options]="recieveGoodsAndServicesList" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueName'"
                [disabled]="true"
                [ngClass]="{'error': validationErrors['recieveGoodsAndServices'] }">
              </ppl-dropdown-select>
              @if (validationErrors['recieveGoodsAndServices']) {
                <span class="pl-1 error-message">{{validationErrors['recieveGoodsAndServices']}}</span>
              }
            </nz-form-control>
          </nz-row>
        </nz-form-item>
      }
  </form>
</div>
<div class="custom-row">
  <ppl-button 
  label="Cancel" 
  icon="fa fa-ban" 
  [customClass]="'alt-button'" 
  [iconPosition]="'left'"
  (click)="cancelEdit()"
  ></ppl-button>    

  <ppl-button 
  label="Save" 
  icon="fa fa-floppy-o" 
  [customClass]="'alt-button'" 
  [iconPosition]="'left'"
  (click)="save()"
  *authorize="[pageId, tabId, 'Demographics', 'section', 'edit']"
  ></ppl-button>
</div>
} @else if(mode==="read" && savedData && secData){
<div nz-row>
  @if(isAttrAvailable('legalName')){
    <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'legalName']">
      <div nz-row>
        <div nz-col nzSpan="12" [nzXs]="9"  class="font-weight-600 pt-2">
          {{ getAttributes("legalName").label }}
        </div>
        <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData.legalName }}</div>
      </div>
    </div>
  }
  @if(isAttrAvailable('businessName')){
    <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'businessName']">
      <div nz-row>
        <div nz-col nzSpan="12" [nzXs]="9"  class="font-weight-600 pt-2">
          {{ getAttributes("businessName").label }}
        </div>
        <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData.businessName }}</div>
      </div>
    </div>
  }
  @if(isAttrAvailable('vendorName')){
    <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'vendorName']">
      <div nz-row>
        <div nz-col nzSpan="12" [nzXs]="9"  class="font-weight-600 pt-2">
          {{ getAttributes("vendorName").label }}
        </div>
        <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData.vendorName }}</div>
      </div>
    </div>
  }
  @if(isAttrAvailable('doingBusinessAs')){
    <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'doingBusinessAs']">
      <div nz-row>
        <div nz-col nzSpan="12" [nzXs]="9"  class="font-weight-600 pt-2">
          {{ getAttributes("doingBusinessAs").label }}
        </div>
        <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData.dbaName }}</div>
      </div>
    </div>
  }
  @if(isAttrAvailable('fname')){
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'fname']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9"  class="font-weight-600 pt-2">
        {{ getAttributes("fname").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData.fname }}</div>
    </div>
  </div>
  } @if(isAttrAvailable('mname')){

  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'mname']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
        {{ getAttributes("mname").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData.mname }}</div>
    </div>
  </div>

  } @if(isAttrAvailable('lname')){
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'lname']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
        {{ getAttributes("lname").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData.lname }}</div>
    </div>
  </div>
  } @if(isAttrAvailable('maiden_name')){

  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'maiden_name']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
        {{ getAttributes("maiden_name").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData.maiden_name }}</div>
    </div>
  </div>

  } @if(isAttrAvailable('dob')){

  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'dob']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
        {{ getAttributes("dob").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData.dob | date : "MM/dd/yyyy"}}</div>
    </div>
  </div>
  } @if(isAttrAvailable('gender')){

  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'gender']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
        {{ getAttributes("gender").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData['gender'] ? getLookupValue(genderList,
        savedData['gender']) :
        savedData['gender']}}</div>
    </div>
  </div>
  }
  @if(isAttrAvailable('conservatorship')){

  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
        {{ getAttributes("conservatorship").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData['conservatorship'] ? getLookupValue(conservatorshipTypes,
        savedData['conservatorship']) :
        savedData['conservatorship']}}</div>
    </div>
  </div>
  }
  @if(isAttrAvailable('servicesAtBusinessLocation')){

  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'servicesAtBusinessLocation']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
        {{ getAttributes("servicesAtBusinessLocation").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData['servicesAtBusinessLocation'] }}</div>
    </div>
  </div>
  }
  @if(isAttrAvailable('servingIndividualsWithDisabilities')){

  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'servingIndividualsWithDisabilities']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
        {{ getAttributes("servingIndividualsWithDisabilities").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData['servingIndividualsWithDisabilities'] }}</div>
    </div>
  </div>
  }
  @if(isAttrAvailable('state')){

  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'state']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
        {{ getAttributes("state").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData.state ? getLookupValue(statesList, savedData.state) :
        savedData.state}}</div>
    </div>
  </div>
  }
  @if(isAttrAvailable('regionalCenterValue')){
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'regionalCenterValue']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
        {{ getAttributes("regionalCenterValue").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData.regionalCenterValue}}</div>
    </div>
  </div>
  }
  @if(isAttrAvailable('relationToParticipant')){
      <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'relationToParticipant']">
        <div nz-row>
          <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
            {{ getAttributes("relationToParticipant").label }}
          </div>          
          <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData.relationToParticipant ? getLookupValue(relationshipOptions, savedData['relationToParticipant']) : savedData.relationToParticipant}}</div>
        </div>
      </div>
    }
  @if(isAttrAvailable('waiver')){

    <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'waiver']">
      <div nz-row>
        <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
          {{ getAttributes("waiver").label }}
        </div>
        <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData['waiver'] ? getLookupValue(waiver,
          savedData['waiver']) :
          savedData['waiver']}}</div>
      </div>
    </div>
  }
  @if(isAttrAvailable('ldssOffice')){

    <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'ldssOffice']">
      <div nz-row>
        <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
          {{ getAttributes("ldssOffice").label }}
        </div>
        <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData['ldssOffice'] ? getLookupValue(ldssOfficeValues,
          savedData['ldssOffice']) :
          savedData['ldssOffice']}}</div>
      </div>
    </div>
  }
  @if(isAttrAvailable('mcoOrgName')){

    <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'mcoOrgName']">
      <div nz-row>
        <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
          {{ getAttributes("mcoOrgName").label }}
        </div>
        <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData.mcoOrgName }}</div>
      </div>
    </div>
  
    }
    @if(isAttrAvailable('currentFI')){

      <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'currentFI']">
        <div nz-row>
          <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
            {{ getAttributes("currentFI").label }}
          </div>
          <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData['currentFI'] ? getLookupValue(currentFIValues,
            savedData['currentFI']) :
            savedData['currentFI']}}</div>
        </div>
      </div>
    }
    @if(isAttrAvailable('fiOrgName')){
  
      <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'fiOrgName']">
        <div nz-row>
          <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
            {{ getAttributes("fiOrgName").label }}
          </div>
          <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData.fiOrgName }}</div>
        </div>
      </div>
    
      }
  @if(isAttrAvailable('eligiblityStartDate')){

    <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'eligiblityStartDate']">
      <div nz-row>
        <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
          {{ getAttributes("eligiblityStartDate").label }}
        </div>
        <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData.eligiblityStartDate | date : "MM/dd/yyyy"}}</div>
      </div>
    </div>
    }
  @if(isAttrAvailable('eligiblityEndDate')){

    <div nz-col nzSpan="12"  [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'eligiblityEndDate']">
      <div nz-row>
        <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
          {{ getAttributes("eligiblityEndDate").label }}
        </div>
        <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData.eligiblityEndDate | date : "MM/dd/yyyy"}}</div>
      </div>
    </div>
    }
    @if(isAttrAvailable('contactStsReasonLkp')){
  
      <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'contactStsReasonLkp']">
        <div nz-row>
          <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
            {{ getAttributes("contactStsReasonLkp").label }}
          </div>
          <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData.contactStsReasonLkp ? getLookupValue(contactStsReasonLkpList, savedData['contactStsReasonLkp']) : savedData.contactStsReasonLkp}}</div>
        </div>
      </div>
    
      }
      @if(isAttrAvailable('contactStsComments')){
  
        <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'contactStsComments']">
          <div nz-row>
            <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
              {{ getAttributes("contactStsComments").label }}
            </div>
            <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData.contactStsComments }}</div>
          </div>
        </div>
      }
      @if(isAttrAvailable('recieveGoodsAndServices')){
        <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'recieveGoodsAndServices']">
          <div nz-row>
            <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
              {{ getAttributes("recieveGoodsAndServices").label }}
            </div>
            <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData['recieveGoodsAndServices'] }}</div>
          </div>
        </div>
      }
</div>
@if(isAttrAvailable('nonProfitStatus')){
  <div nz-row>
    <div nz-col nzSpan="8" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" ngClass="font-weight-600 pt-2">
      {{ getAttributes("nonProfitStatus").label }}
    </div>
  </div>
  <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'taxExempt']">
        <div nz-row>
          <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
            {{ getAttributes("taxExempt").label }}
          </div>
          <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing"> {{ savedData.taxExempt ? getLookupValue(taxExemptOptions, savedData['taxExempt']) : savedData.taxExempt}}</div>
        </div>
      </div>
      <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"  *authorizeFieldView="[pageId, tabId, 'Demographics', 'nprftDocumentationReceived']">
        <div nz-row>
          <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
            {{ getAttributes("nprftDocumentationReceived").label }}
          </div>
          <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData.nprftDocumentationReceived }}</div>
        </div>
      </div>
    </div>
  }

@if(isAttrAvailable('isShowOnDirectory')){
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'isShowOnDirectory']">
    <div nz-row>
      <div nz-col nzSpan="10" ngClass="font-weight-600 pt-2">
        {{getAttributes('isShowOnDirectory').label}}
      </div>
      <div nz-col nzSpan="8" ngClass="pt-2"> {{filledInfo.isShowOnDirectory === true ? 'Yes' : 'No'}}</div>
    </div>
  </div>
}

@if(isAttrAvailable('isProvidingServices')){
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'isProvidingServices']">
    <div nz-row>
      <div nz-col nzSpan="10" ngClass="font-weight-600 pt-2">
        {{getAttributes('isProvidingServices').label}}
      </div>
      <div nz-col nzSpan="8" ngClass="pt-2"> {{filledInfo.isProvidingServices !== null ? (filledInfo.isProvidingServices === true ? 'Yes' : 'No') : '' }}</div>
    </div>
  </div>
}

@if(isAttrAvailable('registerPref')){
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'registerPref']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
        {{ getAttributes("registerPref").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData['registerPref'] ? getLookupValue(prefList,
        savedData['registerPref']) :
        savedData['registerPref']}}</div>
    </div>
  </div>
}
@if(isAttrAvailable('yearsInState')){
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'yearsInState']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
        {{ getAttributes("yearsInState").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{savedData['yearsInState']}}</div>
    </div>
  </div>
}

<div nz-row>
  @if(isAttrAvailable('race')){  
      <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'race']">
        <div nz-row>
          <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
            {{ getAttributes("race").label }}
          </div>          
          <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData.race ? getLookupValue(raceOptions, savedData['race']) : savedData.race}}</div>
        </div>
      </div>
    }
  @if(isAttrAvailable('height')){
      <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'height']">
        <div nz-row>
          <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
            {{ getAttributes("height").label }}
          </div>
          <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{(savedData.heightFeet || savedData.heightInches)? savedData.heightFeet + "'" + savedData.heightInches +"''" :savedData.heightFeet}}</div>
        </div>
      </div>
    }
    @if(isAttrAvailable('weight')){
      <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'weight']">
        <div nz-row>
          <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
            {{ getAttributes("weight").label }}
          </div>
          <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData.weight }}</div>
        </div>
      </div>

      }
      @if(isAttrAvailable('eyeColor')){
        <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'eyeColor']">
          <div nz-row>
            <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
              {{ getAttributes("eyeColor").label }}
            </div>
            <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ getLookupValue(eyeColors, savedData['eyeColor']) || savedData.eyeColor}}</div>
          </div>
        </div>
      }
    @if(isAttrAvailable('hairColor')){

      <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'hairColor']">
        <div nz-row>
          <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
            {{ getAttributes("hairColor").label }}
          </div>
          <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ getLookupValue(hairColors, savedData['hairColor']) || savedData.hairColor}}</div>
        </div>
      </div>
    }
    @if(isAttrAvailable('birthPlace')){
      <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12" *authorizeFieldView="[pageId, tabId, 'Demographics', 'birthPlace']">
        <div nz-row>
          <div nz-col nzSpan="12" [nzXs]="9" class="font-weight-600 pt-2">
            {{ getAttributes("birthPlace").label }}
          </div>
          <div nz-col nzSpan="12" [nzXs]="15" class="pt-2 mobile-value-left-paddiing">{{ savedData.birthCity}} {{(savedData.birthState? " , "+ savedData.birthState :savedData.birthState) }} {{(savedData.birthCountry?" , " +savedData.birthCountry: savedData.birthCountry)}}</div>
        </div>
      </div>
      }
    </div>
} @else{
<nz-row>
  <p>No Data found</p>
</nz-row>
}
